//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.PostControl.js";
let d=[[[0,"ActiveView",1,0],[0,"Delay",1,0],[0,"JointsLimits",1,0]],[[["jointTag","currentStep","displacement","displacementUnit"],"GetArticulationJointsDisplacement",{},1,0],[["numSteps","jointTags","stepSize","stepSizeUnit"],"ArticulationSolve",{},4,0],[["jointTags","displacement","displacementUnit"],"ArticulationSolve1",{},3,0],[[],"StepToDesignPosition",{},0,0],[[],"StepToAssemblyPosition",{},0,0],[[],"Stop",{},0,0],[[],"Finish",{},0,0],[["numJoints","jointTags"],"GetArticulationJoints",{},0,0]],[]];
SPLM.Motion.ArticulationControl = class extends SPLM.Motion.PostControl{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ArticulationControl";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;